export const ORIGIN = 'origin';
export const DESTINATION = 'destination';
